import { html, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import css from './lib-sidebar-splitter.css';

/** Flexible space between sidebar item groups. */
@customElement('lib-sidebar-splitter')
export class LibSidebarSplitter extends LibElement {
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(css)];
  override render() { return html``; }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-sidebar-splitter': LibSidebarSplitter; }
}
